import { render, staticRenderFns } from "./KsFilterBarPair.vue?vue&type=template&id=33b9996c"
import script from "./KsFilterBarPair.vue?vue&type=script&lang=js"
export * from "./KsFilterBarPair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports